import styles from "../css/Scroller.module.css"
import { useScroll } from "framer-motion"
import React, { forwardRef, useEffect, useRef, useState, useImperativeHandle } from "react"
// dependency update - change useage
import { animate } from "animejs"

const Scroller = forwardRef(({ full, callback, className, buttons, dots = true, children, style, areaStyle, dotsStyle, dotStyle, activeDotStyle }, ref) => {

	useImperativeHandle(ref, () => {
		return {
			getCurrent,
			slideTo,
			slideLeft,
			slideRight
		}
	})
	
	//#region Variables
	const scrollArea = useRef()
	const slider = useRef()
	const { scrollX } = useScroll({ container: slider })
	const [scrollBehaviorSupport, setScrollBehaviorSupport] = useState(false)
	const before = useRef()
	const [dotCount, setDotCount] = useState()
	//#endregion

	//#region Effects
	useEffect(() => {
		// dots && setScrollDots()
		bindScrollEvent()
		checkScrollBehaviorSupport()

		setDotCount(slider.current.children.length)

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [children])
	//#endregion

	//#region Methods
	const checkScrollBehaviorSupport = () => {
		if (typeof document.body.style.scrollBehavior !== "undefined") {
			setScrollBehaviorSupport(true)
			slider.current.style.scrollBehavior = "smooth"
		}
	}

	const setScrollDots = () => {
		// const count = slider.current.querySelectorAll(".scrollerItem").length
		const count = slider.current.children.length
		let dots = scrollArea.current.querySelector(`.${styles.dots}`)
		if (!dots) {
			dots = document.createElement("div")
			dots.classList.add(styles.dots)
			scrollArea.current.append(dots)
		}
		if (dotsStyle) dots.classList.add(dotsStyle)
		dots.innerHTML = ""
		if (!count) return
		for (let i = 0; i < count; i++) {
			const dot = document.createElement("div")
			if (i === 0) dot.classList.add(activeDotStyle ? activeDotStyle : styles.on)
			dot.classList.add(styles.dot)
			if (dotStyle) dot.classList.add(dotStyle)
			dots.append(dot)
		}
	}

	const getCurrent = () => Math.round((scrollX.current / slider.current.scrollWidth) * slider.current.childElementCount) + 1 || 1

	const bindScrollEvent = () => {
		slider.current.addEventListener("scroll", (e) => {
			if (!slider.current || !scrollArea.current) return false
			const n = getCurrent()
			if (typeof before.current === "undefined") before.current = n
			const dots = scrollArea.current.querySelector(`.${styles.dots}`)
			if (dots) {
				dots.querySelector(`.${activeDotStyle ? activeDotStyle : styles.on}`)?.classList.remove(`${activeDotStyle ? activeDotStyle : styles.on}`)
				dots.querySelector(`:nth-child(${n})`)?.classList.add(`${activeDotStyle ? activeDotStyle : styles.on}`)
				if (before.current !== n) {
					callback && callback(n)
					before.current = n
				}
			}
		})
	}

	const slideLeft = () => {
		slideTo(getCurrent() - 1)
	}

	const slideRight = () => {
		slideTo(getCurrent() + 1)
	}

	const slideTo = (current) => {
		const slideWidth = slider.current.firstChild.clientWidth
		const margin = parseFloat(window.getComputedStyle(slider.current.firstChild).marginRight)
		const to = (current - 1) * (slideWidth + margin) - (document.body.clientWidth - slideWidth - margin * 2) / 2
		if (scrollBehaviorSupport) {
			slider.current.scrollTo(to, 0)
		} else {
			animateTo(to)
		}
	}

	const animateTo = (to, duration) => {
		animate(
			slider.current,{
			scrollLeft: to,
			ease: "inOutQuad",
			duration: duration || 300,
			onBegin() {
				// slider.current.classList.remove("xMandatory")
			},
			onComplete() {
				// slider.current.classList.add("xMandatory")
				slider.current.scrollLeft = to
				console.log(to)
			},
		})
	}
	//#endregion

	/* const setChildren = () => {
		console.log(children)
		if (children) {
			const childs = []
			children.map((child, key) => {
				console.log("child", child)
				if (!child) return
				childs.push(React.cloneElement(child, { className: `${styles.item} ${child.props?.className ?? ""}`, key }))
			})

			setSlides(childs)
		}
	} */

	return (
		<div className={styles.ScrollArea} ref={scrollArea} style={areaStyle}>
			<ul ref={slider} className={`${styles.slider}${full ? ` ${styles.full}` : ""}${className ? ` ${className}` : ""}`} style={style}>
				{children}
			</ul>
			{buttons && (
				<>
					<div onClick={slideLeft} className={`${styles.button} ${styles.left}`}></div>
					<div onClick={slideRight} className={`${styles.button} ${styles.right}`}></div>
				</>
			)}

			{dots && dotCount > 0 && (
				<div className={`${styles.dots} mt_20`}>
					{[...Array(dotCount)].map((item, index) => <div key={index} className={`${styles.dot} ${index === 0 ? styles.on : ""}`} />)}
				</div>
			)}
		</div>
	)
})

export default Scroller
